import React from 'react';

type Props = {
  title?: string;
  categoryTitle?: string;
  titleClassName?: string;
  spanClassName?: string;
};

export default function ProductTitles({
  title,
  categoryTitle,
  titleClassName,
  spanClassName,
}: Props) {
  if (!title) {
    return null;
  }

  return (
    <div>
      <h1 className={titleClassName} aria-label={title} tabIndex={0}>
        {title}
      </h1>
      {categoryTitle && (
        <span className={spanClassName} aria-label={categoryTitle} tabIndex={0}>
          {categoryTitle}
        </span>
      )}
    </div>
  );
}
